import { makeStyles } from '@material-ui/core';
import React from 'react';

import { FontSizes } from '../../core/config/mainTheme';

interface Props {
  rows: any[];
}

const ReadableStatementView: React.FC<Props> = ({ rows }) => {
  const classes = useStyles();
  const data: JSX.Element[] = [];
  rows.forEach((r, i) => {
    data.push(
      <div className={classes.row} key={i}>
        <div className={classes.columnLabel}>{r.label}</div>
        <div className={classes.columnValues}>{r.value}</div>
      </div>,
    );
  });

  return <>{data}</>;
};

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    fontSize: FontSizes.size.small,
    paddingBottom: theme.spacing(4),
  },
  columnLabel: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '30%',
    flex: '1',
  },
  columnValues: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '70%',
    flex: '1',
    fontWeight: 'bold',
  },
}));

export default ReadableStatementView;
